import { GetAppSubscriptionsResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { appSubscriptionKeys } from "../queryKeys";
import { useIsAdmin } from "../user-auths/is-admin";

const getAppSubscriptions = async () => {
  const resp = await api.get<GetAppSubscriptionsResponseBodyType>(
    `/v2/organizations/app-subscriptions`
  );
  return resp.data;
};

export const useAppSubscriptions = (
  options?: QueryOptions<GetAppSubscriptionsResponseBodyType, Error>
) => {
  const org = useGetOrg();
  const isAdmin = useIsAdmin();
  return useQuery<GetAppSubscriptionsResponseBodyType, Error>({
    ...options,
    queryKey: appSubscriptionKeys.one(org.data.org.id || ""),
    queryFn: async () => getAppSubscriptions(),
    enabled: isAdmin,
  });
};
